import React from "react";
import { useNavigate } from "react-router-dom";
import { BsInfoCircle } from "react-icons/bs";

import { useDashboard } from '../context/DashboardContext';

export default function RotaToday() {
  const navigate = useNavigate();

  const { dashboardData, loading, errors } = useDashboard();
  const teamRota = dashboardData.rotaToday || [];

  const handleViewFullRota = () => {
    navigate("/rota");
  };

  return (
    <div className="max-w-xl w-full bg-white border border-slate-100 rounded-3xl p-6 shadow-sm font-sans text-slate-800">
      ```
      {/* HEADER SECTION */}
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-lg font-bold text-slate-900">Rota – Today</h2>

        <button
          type="button"
          onClick={handleViewFullRota}
          className="text-[#3a31d8] text-xs font-bold hover:underline"
        >
          View Full Rota
        </button>
      </div>
      <p className="text-slate-400 text-xs font-medium mb-6">
        Your team and assigned checks
      </p>
      {/* TABLE HEADERS */}
      <div className="grid grid-cols-12 text-[11px] font-bold text-slate-400 tracking-wider uppercase pb-3 border-b border-slate-100">
        <div className="col-span-4">Team Member</div>
        <div className="col-span-3">Role</div>
        <div className="col-span-5">Assigned Checks</div>
      </div>
      {/* ROTA ROWS */}
      <div className="divide-y divide-slate-50 mb-6">
        {!teamRota.length && <p className="py-4 text-sm text-slate-400">{loading.rotaToday ? 'Loading…' : errors.rotaToday ? 'Unable to load rota.' : 'Rota assignments are not tracked in the current schema.'}</p>}
        {teamRota.map((member) => (
          <div
            key={member.id}
            className="grid grid-cols-12 items-center py-4 text-sm"
          >
            {/* Team Member Name */}
            <div className="col-span-4 font-bold text-slate-900 pr-2">
              {member.name}
            </div>

            {/* Member Role */}
            <div className="col-span-3 text-slate-500 font-medium">
              {member.role}
            </div>

            {/* Assigned Badges */}
            <div className="col-span-5 flex flex-wrap gap-2">
              {member.checks.map((check, idx) => (
                <span
                  key={idx}
                  className={`text-[11px] font-semibold px-2.5 py-1 rounded-lg tracking-wide ${
                    check.type === "green"
                      ? "bg-[#edf9f1] text-[#228643]"
                      : "bg-[#fff7ed] text-[#d97706]"
                  }`}
                >
                  {check.label}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* BOTTOM INFO BANNER */}
      <div className="bg-[#f0f0ff] rounded-xl p-3.5 flex items-start gap-2 text-xs font-semibold text-[#4d3df5]">
        <BsInfoCircle className="text-sm mt-0.5 shrink-0" />

        <p className="leading-tight">
          Rota suggests and assigns the right checks to the right people.
        </p>
      </div>
    </div>
  );
}
